// extracted by mini-css-extract-plugin
export var actions = "_fc-d";
export var benefitCard = "_fc-a";
export var benefitIcon = "_fc-b";
export var benefitLabel = "_fc-c";
export var benefits = "_fc-9";
export var bodyText = "_fc-8";
export var closeButton = "_fc-2";
export var content = "_fc-3";
export var eyebrow = "_fc-4";
export var heading = "_fc-5";
export var image = "_fc-f";
export var imagePanel = "_fc-e";
export var modal = "_fc-0";
export var shell = "_fc-1";
export var title = "_fc-6";
export var titleOffer = "_fc-7";